module.exports = __webpack_public_path__ + "img/icon_img_14.5c83a8b4.png";